/// <reference path="DOMAttached.js" />

class FriendshipRequest extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.options = options;
		this.el = document.getElementById(el);

		this.triggerOK = document.getElementById(this.options.triggerOK);
		this.triggerClose = document.getElementById(this.options.triggerClose);
		this.statusfield = document.getElementById(this.options.statusfield);
		this.inputCode = document.getElementById(this.options.inputCode);
		this.pbody = document.getElementById(this.options.pbody);
		this.overlay = document.getElementById(this.options.overlay);

		this.safeObserve(this.triggerOK, 'click', this.onConfirm.bind(this));

		if (this.options.inputCodeShowTrigger != undefined) {
			this.inputCodeShowTrigger = document.getElementById(this.options.inputCodeShowTrigger);
			this.safeObserve(this.inputCodeShowTrigger, 'click',
				this.showCodeInput.bind(this));
		}
	}

	showCodeInput(event) {
		this.inputCode.style.display = 'block';
		this.inputCodeShowTrigger.style.display = 'none';
	}

	onConfirm(event) {
		// add friendcode to callback url (if present)
		var icode = '';
		if (this.inputCode != undefined && this.inputCode != null) {
			icode = this.inputCode.querySelector('input').value;
			if ((icode == undefined || icode == "")
				&& this.inputCodeShowTrigger == undefined)
				icode = "invalid";
		}

		var req = axios(new UrlTemplate(this.options.link).r('PLH_friendcode', icode).url, {
			method: 'post',
			headers: {
				'content-type': 'application/x-www-form-urlencoded'
			}
		}).then(this.onResponse.bind(this));
	}

	onResponse(req) {
		var json = req.data;
		if (json.end) {
			this.pbody.innerHTML = '';
			if (json.reload)
				this.safeObserve(this.triggerClose, 'click', this.onClose.bind(this));
		}
		this.statusfield.innerHTML = json.ret;
		this.overlay.position();
	}

	onClose(req) {
		window.location.reload();
	}
}
